var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-image" }, [
    _c(
      "div",
      { staticClass: "hero-image--container" },
      [
        _c(
          "base-image",
          _vm._b(
            { staticClass: "hero-image--image", attrs: { loading: "lazy" } },
            "base-image",
            _vm.image,
            false
          )
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a25ab9d0", { render: render, staticRenderFns: staticRenderFns })
  }
}